import { NgForm } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-vestidos',
  templateUrl: './edit-vestidos.component.html',
  styleUrls: ['./edit-vestidos.component.scss'],
})
export class EditVestidosComponent implements OnInit {
  public errorMessage = '';
  private vestidoID = '';
  public isLoading = false;
  public mode = 'create';
  public edited = false;

  public textarea = '';
  public textareaParsed: any;

  public vestido: {
    vestido_id: string;
    vestido_date: string;
    vestido_date_full: any;
    atuendos: Array<{ atuendo_description: string; materiales: string[] }>;
    complementos: Array<{
      complemento_description: string;
      materiales: string[];
    }>;

    images: Array<{
      image_path: string | any;
      preview: any;
      num_foto: string | number;
      sort_id: string | number;
    }>;
  } = {
    vestido_id: '',
    vestido_date: '',
    vestido_date_full: '',
    atuendos: [],
    complementos: [],
    images: [{ image_path: null, preview: null, num_foto: 1, sort_id: 1 }],
  };

  constructor() {}

  ngOnInit(): void {
    this.newImagenes();
    this.newAtuendos();
    this.newComplementos();
  }

  public parseTextArea(): void {
    this.textareaParsed = this.textarea.split('\n');
    console.log('textareaParsed: ', this.textareaParsed);
  }
  onAddImagen(): void {
    this.vestido.images.push({
      image_path: '',
      preview: null,
      num_foto: 0,
      sort_id: 1,
    });
    //this.imagenesEmpty = false;

    setTimeout(() => {
      console.log('imagePicker_' + (this.vestido.images.length - 1));
      console.log(
        document.getElementById(
          'imagePicker_' + (this.vestido.images.length - 1)
        )
      );
      document
        .getElementById('imagePicker_' + (this.vestido.images.length - 1))
        ?.click();
    }, 50);
  }

  onImagePicked(event: Event, i: number): void {
    console.log(event);
    const fileArray: any = (event.target as HTMLInputElement).files
      ? (event.target as HTMLInputElement).files
      : null;
    if (fileArray && fileArray.length) {
      this.vestido.images[i].image_path = fileArray[0];
      console.log('this.vestido.image: ', this.vestido.images);
      const reader = new FileReader();
      reader.onload = () => {
        //this.imagePreview[i] = reader.result;
        this.vestido.images[i].preview = reader.result;
      };
      reader.readAsDataURL(this.vestido.images[i].image_path);
    }
  }
  onDeleteImagen(i: number): void {
    this.vestido.images.splice(i, 1);
    if (this.vestido.images.length === 0) {
      this.newImagenes();
    }
  }

  private newAtuendos(): void {
    this.vestido.atuendos = [];
    this.vestido.atuendos.push({
      atuendo_description: '',
      materiales: [],
    });
    //this.ingredientesEmpty = true;
  }
  private newComplementos(): void {
    this.vestido.complementos = [];
    this.vestido.complementos.push({
      complemento_description: '',
      materiales: [],
    });
    //this.condimentosEmpty = true;
  }

  onAddAtuendo(form: NgForm): void {
    console.log(form);
    console.log('Atuendos before push: ', this.vestido.atuendos);
    this.vestido.atuendos.push({
      atuendo_description: '',
      materiales: [],
    });
    console.log('Atuendos after push: ', this.vestido.atuendos);
    //this.ingredientesEmpty = false;
  }

  onDeleteAtuendo(i: number): void {
    this.vestido.atuendos.splice(i, 1);
    if (this.vestido.atuendos.length === 0) {
      this.newAtuendos();
    }
  }

  onAddComplemento(form: NgForm): void {
    console.log(form);
    this.vestido.complementos.push({
      complemento_description: '',
      materiales: [],
    });
    //this.condimentosEmpty = false;
  }

  onDeleteComplemento(i: number): void {
    this.vestido.complementos.splice(i, 1);
    if (this.vestido.complementos.length === 0) {
      this.newComplementos();
    }
  }

  private newImagenes(): void {
    this.vestido.images = [];
    this.vestido.images.push({
      image_path: null,
      preview: null,
      num_foto: 0,
      sort_id: 1,
    });
    //this.imagenesEmpty = true;
  }

  onSubmit(form: NgForm): void {
    console.log(form);
    if (!form.invalid) {
      /*this.usersService
        .updateUser(
          form.value.firstname,
          form.value.surname,
          form.value.email,
          form.value.roleID,
          this.userID
        )
        .subscribe(
          (result) => {
            console.log(result);
            this.router.navigate(['/usuarios'], {
              state: { data: 'El usuario/a ha sido editado con éxito.' },
            });
          },
          (error) => {
            this.errorMessage = error.error.error.message || '';
            if (
              this.errorMessage &&
              this.errorMessage.includes('Duplicate entry') &&
              this.errorMessage.includes('email')
            ) {
              this.errorMessage =
                'El e-mail ya existe. Por favor, especifique otro.';
            }
            window.scroll(0, 0);
          }
        );*/
    }
  }
}
